export default class Effect {

    constructor() {

        this.init();

    }

    init() {

        // タイトル演出用の要素を生成
        this.createEffectEl();

    }

    createEffectEl() {

        const $headArray = [...document.querySelectorAll('.js-head')],
            row = 4, col = 42;

        $headArray.forEach($head => {
            for (let i = 0; i < row; i++) {
                const $row = document.createElement('ul');
                for (let j = 0; j < col; j++) {
                    const delay = Math.floor(Math.random() * 0.6 * Math.pow(10, 2)) / Math.pow(10, 2);
                    $row.innerHTML += `<li style="transition-delay: ${delay}s;"></li>`;
                }
                $head.insertBefore($row, $head.firstChild);
            }
        });

    }

}